import {FC} from 'react'

import {ContentCard} from '@/components/common/content/ContentCard'
import {Locale} from '@/utils/constants'
import {CountryGuideBasicInfo} from '@/utils/contentful'
import {getJurisdictionFlagSrc} from '@/utils/countries/flags'
import {alpha2ToName} from '@/utils/countries/translations'
import {routeTo} from '@/utils/router'

import {CardListLayout} from '../common/cards/CardListLayout'
import {CardWrapper} from '../common/cards/CardWrapper'

type CountryGuideCardListProps = {
  title: string
  cards: CountryGuideBasicInfo[]
  numOfCardsPerRow?: number
  showDescription?: boolean
}

export const CountryGuideCardList: FC<CountryGuideCardListProps> = ({
  title,
  cards,
  numOfCardsPerRow,
  showDescription = true,
}) => (
  <CardListLayout title={title}>
    {cards.map(({countryCode, countrySlug, homeCardDescription}) => {
      const countryName = alpha2ToName(countryCode, Locale.en)
      const flagSrc = getJurisdictionFlagSrc(countryCode)

      return (
        <CardWrapper key={countryCode} numOfCardsPerRow={numOfCardsPerRow}>
          <ContentCard
            title={countryName}
            imageSrc={flagSrc ?? undefined}
            imageAlt={flagSrc ? `${countryCode} flag` : undefined}
            description={showDescription ? homeCardDescription : undefined}
            linkHref={routeTo.countryGuide(countrySlug)}
            // A prefetch would be the whole static guide (~180 kB), once per card in view.
            prefetch={false}
            trackedEvent={{
              name: 'Country guide card is clicked',
              parameters: {countryCode},
            }}
          />
        </CardWrapper>
      )
    })}
  </CardListLayout>
)
